import { useIsWebView } from '@/hooks/useIsWebView';
import {
  useBrand,
  usePersistedSessionState,
} from '@edreamsodigeo/frontend-core';
import {
  backToSearch,
  backToSearchInApp,
} from '@/components/FunnelErrors/utils/backToSearchNavigation';

export const useErrorNavigation = () => {
  const [searchParameters] = usePersistedSessionState('searchParameters', {});
  const isWebview = useIsWebView();
  const brand = useBrand();

  const reloadSearch = () => {
    if (isWebview) {
      window.location.assign(backToSearchInApp(searchParameters, brand));
    } else {
      window.location.assign(backToSearch(searchParameters));
    }
  };

  const redirectHome = () => {
    if (isWebview) {
      window.location.assign(backToSearchInApp(searchParameters, brand, false));
    } else {
      window.location.assign('/');
    }
  };

  return {
    reloadSearch,
    redirectHome,
  };
};
